// extracted by mini-css-extract-plugin
export default {"inputLabel":"InputLabel-module__inputLabel___xgt3h","inputLabel-text":"InputLabel-module__inputLabel-text___iEd0o","error":"InputLabel-module__error___wUzg3"};